export default __webpack_public_path__ + "static/media/first.2da2440a.png";